import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export const useRestoreComponent = (
  options?: UseMutationOptions<any, Error, number>
) => {
  return useMutation({
    ...options,
    mutationKey: ["restoreComponent"],
    mutationFn: async (componentId: number) => {
      return axiosInstance
        .post(`/reports/components/${componentId}/restore`)
        .then((res) => res.data);
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Produkt dodany do następnego raportu.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "restore-component",
      });
      queryClient.invalidateQueries({ queryKey: ["reportComponents"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      const errorMessage =
        error?.data?.message || "Błąd podczas dodawania produktu do raportu.";
      Toast({
        message: errorMessage,
        type: TOAST_TYPES_ENUM.ERROR,
        id: "restore-component",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useRestoreComponent;
